import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap';
import { RegistrationUtilService } from '../../registration-util.service';
import { UserSession } from '@mem-shared/user-session.ts';
/**
 * Leave form modal - Display a cofirmation message
 * Stating Are you sure you want to leave this page?
 */
@Component({
  selector: 'mem-confirm-info-reenter-moda',
  templateUrl: './confirm-info-reenter-modal.component.html',
  styleUrls: ['./confirm-info-reenter-modal.component.scss']
})
export class ConfirmInfoReenterModalComponent implements OnInit {

  constructor(public bsModalRef: BsModalRef,
  private router: Router,
  private userSession: UserSession,
  private registrationUtilService: RegistrationUtilService) { }

  ngOnInit() {
    this.userSession.setSession('alllowRefreshRegistration', false);
  }

  choose(choice: boolean): void {
    if(choice){
      this.userSession.setSession('alllowRefreshRegistration', true);
      if(this.router.url.toString().indexOf('step4') !==-1 || this.router.url.toString().indexOf('step5') !==-1 || this.router.url.toString().indexOf('step6') !==-1){
        this.router.navigate(['/registration/step3']);
      } else if(this.router.url.toString().indexOf('step7') !==-1){
        this.router.navigate(['/registration/step6']);
      } else if(this.router.url.toString().indexOf('step8') !==-1){
        this.router.navigate(['/registration/step7']);
      } else if(this.router.url.toString().indexOf('step9') !==-1){
        this.router.navigate(['/registration/step8']);
      } else {
        this.router.navigate(['/registration/step1']);
      }  
    }
    this.registrationUtilService.reEnterContactInformation$.next(choice);
  }
}



// WEBPACK FOOTER //
// ./src/app/new-registration/modals/confirm-info-reenter-modal/confirm-info-reenter-modal.component.ts